import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppFloat from '../../components/feature/WhatsAppFloat';
import { useState } from 'react';

export default function About() {
  const [isMuted, setIsMuted] = useState(true);

  const toggleMute = () => {
    setIsMuted(!isMuted);
    const iframe = document.querySelector('#about-video-iframe') as HTMLIFrameElement;
    if (iframe) {
      const currentSrc = iframe.src;
      if (isMuted) {
        iframe.src = currentSrc.replace('mute=1', 'mute=0');
      } else {
        iframe.src = currentSrc.replace('mute=0', 'mute=1');
      }
    }
  };

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section 
          className="py-20 relative"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=Professional%20printing%20company%20team%20working%20together%20in%20modern%20office%2C%20diverse%20group%20of%20designers%20and%20printing%20specialists%2C%20creative%20workspace%20with%20printing%20samples%2C%20teamwork%20collaboration%2C%20bright%20modern%20office%20environment%2C%20professional%20atmosphere&width=1920&height=600&seq=about-hero&orientation=landscape')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
          <div className="absolute inset-0 bg-black/50"></div>
          <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
              Acerca de Lion Urban
            </h1>
            <p className="text-xl text-gray-200 max-w-3xl mx-auto">
              Más que impresión, somos el impulso creativo detrás de marcas que quieren destacar
            </p>
          </div>
        </section>

        {/* Company Story */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center lg:ml-24">
              <div className="flex flex-col justify-center">
                <h2 className="text-4xl font-bold text-gray-900 mb-6">
                  Nuestra Historia
                </h2>
                <p className="text-lg text-gray-600 mb-6">
                  Lion Urban nace del sueño y la determinación de una Familia de 3 que decidió apostarlo todo por su pasión: el diseño y la publicidad.
                  Con esfuerzo, dedicación y una enorme voluntad de salir adelante, comenzaron desde cero, aprendiendo, creando y creyendo en el poder de las ideas.
                </p>
                <p className="text-lg text-gray-600 mb-6">
                  Lo que inició como un pequeño proyecto se transformó en un negocio con visión urbana, moderno y lleno de energía.
                </p>
                <p className="text-lg text-gray-600 mb-6">
                  Lion Urban representa esas ganas de crecer, de innovar, de dejar huella en cada impresión y en cada diseño que impulsa a otras marcas.
                </p>
                <p className="text-lg text-gray-600 mb-6">
                  Hoy seguimos avanzando con la misma fuerza con la que empezamos, creyendo en los sueños, en el trabajo duro y en el arte de crear cosas que inspiran.
                </p>
                <div className="grid grid-cols-2 gap-6 mt-4">
                  <div className="text-center">
                    <div className="text-3xl font-bold text-teal-600 mb-2">500+</div>
                    <div className="text-gray-600">Clientes Satisfechos</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-teal-600 mb-2">5+</div>
                    <div className="text-gray-600">Años de Experiencia</div>
                  </div>
                </div>
              </div>
              <div className="flex justify-center items-center">
                {/* Rectángulo vertical con video */}
                <div 
                  className="relative bg-white rounded-2xl overflow-hidden shadow-2xl"
                  style={{ width: '360px', height: '640px' }}
                >
                  <iframe
                    id="about-video-iframe"
                    className="w-full h-full"
                    src={`https://www.youtube.com/embed/o8444czyiWY?autoplay=1&mute=${isMuted ? '1' : '0'}&loop=1&playlist=o8444czyiWY&controls=0&modestbranding=1&playsinline=1&rel=0`}
                    title="Video de nuestro trabajo"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{ border: 'none' }}
                  ></iframe>

                  {/* Botón de control de sonido - Esquina inferior izquierda */}
                  <button
                    onClick={toggleMute}
                    className="absolute bottom-4 left-4 z-30 bg-black/70 hover:bg-black/90 text-white rounded-full p-3 transition-all duration-300 shadow-lg backdrop-blur-sm cursor-pointer w-12 h-12 flex items-center justify-center"
                    aria-label={isMuted ? 'Activar sonido' : 'Desactivar sonido'}
                  >
                    {isMuted ? (
                      <i className="ri-volume-mute-fill text-xl w-6 h-6 flex items-center justify-center"></i>
                    ) : (
                      <i className="ri-volume-up-fill text-xl w-6 h-6 flex items-center justify-center"></i>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Mission & Vision */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                Misión y Visión
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Nuestro objetivo es claro: hacer que tu marca se vea brutal y hable por sí sola.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
              <div className="bg-white p-8 rounded-xl shadow-lg">
                <div className="w-16 h-16 bg-teal-500 text-white rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-flag-fill text-2xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                  Nuestra Misión
                </h3>
                <p className="text-gray-600 text-center mb-4">
                  En Lion Urban vivimos la publicidad con actitud.
                  Nos enfocamos en ofrecer soluciones visuales con calidad, estilo y carácter, asegurando que cada cliente se lleve más que un trabajo: una experiencia.
                </p>
                <p className="text-gray-600 text-center">
                  Nos apasiona lo que hacemos, por eso cuidamos cada detalle, escuchamos, proponemos y resolvemos. Porque no solo diseñamos: dejamos huella en cada proyecto.
                </p>
              </div>
              <div className="bg-white p-8 rounded-xl shadow-lg">
                <div className="w-16 h-16 bg-teal-500 text-white rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-eye-fill text-2xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                  Nuestra Visión
                </h3>
                <p className="text-gray-600 text-center mb-4">
                  Ser una agencia publicitaria referente a nivel nacional, reconocida por su creatividad, compromiso y profesionalismo.
                  Queremos que cuando alguien piense en impacto visual, piense en Lion Urban: un equipo que transforma ideas en resultados.
                </p>
                <p className="text-gray-600 text-center">
                  Queremos que cuando la gente vea algo bien hecho, diga: "¡Eso es Lion Urban!".
                  Una empresa que crece con actitud, profesionalismo y una vibra que se nota en cada diseño.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Values */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                Nuestros Valores
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {[
                {
                  icon: 'ri-heart-fill',
                  title: 'Pasión',
                  description: 'Amamos lo que hacemos y se nota en cada entrega. No solo trabajamos: vivimos cada proyecto como si fuera nuestro.'
                },
                {
                  icon: 'ri-shield-check-fill',
                  title: 'Calidad',
                  description: 'Nada sale de Lion Urban si no está impecable. Somos perfeccionistas con estilo: exigentes con nosotros, exigentes con el resultado.'
                },
                {
                  icon: 'ri-lightbulb-fill',
                  title: 'Innovación',
                  description: 'No seguimos tendencias, las creamos. Siempre estamos buscando nuevas formas de sorprender y mejorar.'
                },
                {
                  icon: 'ri-team-fill',
                  title: 'Colaboración',
                  description: 'Sabemos que las mejores ideas nacen en equipo. Conectamos talentos, ideas y energía para romperla juntos.'
                }
              ].map((value, index) => (
                <div key={index} className="text-center p-6 bg-white rounded-xl shadow-lg">
                  <div className="w-16 h-16 bg-teal-500 text-white rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className={`${value.icon} text-2xl`}></i>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">
                    {value.title}
                  </h3>
                  <p className="text-gray-600">
                    {value.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
